
import { Contact } from "@/components/Contact";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const ContactPage = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Ldc8nMqAAAAADSDwtxozDQpOUiRZez_06MP4NbJ">
      <div className="pt-20">
        <Contact />
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default ContactPage;
